<app-dialog-container>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <h1 mat-dialog-title>{{ title }}</h1>
    </div>
    <div>
      <button
        *ngIf="type === typeCesEnum.EDIT"
        mat-icon-button
        (click)="changeType(typeCesEnum.SHOW)"
      >
        <mat-icon class="btn-show">visibility</mat-icon>
      </button>
    </div>
  </div>
  
  <dynamic-form
    [config]="config"
    #form="dynamicForm"
    [typeCes]="type"
    (onCancel)="onCancel()"
    (onSubmit)="onSubmit($event)"
  >
  </dynamic-form>
</app-dialog-container>
